import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
export function ResizableTableHeader({ children, width, onResize, onDragStart, onDragEnd, className = '', minWidth = 50, }) {
    const [isResizing, setIsResizing] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const thRef = useRef(null);
    const startXRef = useRef(0);
    const startWidthRef = useRef(0);
    useEffect(() => {
        if (!isResizing)
            return;
        const handleMouseMove = (e) => {
            const delta = e.clientX - startXRef.current;
            const newWidth = Math.max(minWidth, startWidthRef.current + delta);
            onResize(newWidth);
        };
        const handleMouseUp = () => {
            setIsResizing(false);
        };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing, onResize, minWidth]);
    const handleResizeStart = (e) => {
        e.preventDefault();
        e.stopPropagation();
        startXRef.current = e.clientX;
        startWidthRef.current = width;
        setIsResizing(true);
    };
    const handleDragStart = (e) => {
        setIsDragging(true);
        if (onDragStart)
            onDragStart();
        // Create a custom drag image
        const dragImage = document.createElement('div');
        dragImage.textContent = 'Moving column...';
        dragImage.style.position = 'absolute';
        dragImage.style.top = '-1000px';
        dragImage.style.padding = '8px';
        dragImage.style.backgroundColor = '#3b82f6';
        dragImage.style.color = 'white';
        dragImage.style.borderRadius = '4px';
        document.body.appendChild(dragImage);
        e.dataTransfer.setDragImage(dragImage, 0, 0);
        setTimeout(() => document.body.removeChild(dragImage), 0);
    };
    const handleDragEnd = () => {
        setIsDragging(false);
        if (onDragEnd)
            onDragEnd();
    };
    return (_jsx("th", { ref: thRef, className: `relative ${className} ${isDragging ? 'opacity-50' : ''}`, style: { width: `${width}px`, minWidth: `${width}px`, maxWidth: `${width}px` }, draggable: true, onDragStart: handleDragStart, onDragEnd: handleDragEnd, children: _jsxs("div", { className: "flex items-center justify-between", children: [_jsx("div", { className: "flex-1", children: children }), _jsx("div", { className: `absolute right-0 top-0 bottom-0 w-1 cursor-col-resize hover:bg-primary-500 ${isResizing ? 'bg-primary-600' : ''}`, onMouseDown: handleResizeStart, onClick: (e) => e.stopPropagation(), children: _jsx("div", { className: "absolute right-0 top-0 bottom-0 w-4 -translate-x-1.5" }) })] }) }));
}
//# sourceMappingURL=ResizableTableHeader.js.map